var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandshakeDealSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508 508",
    style: {
      enableBackground: "new 0 0 508 508"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#84DBFF"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M355.2,295.6l-110.4-116l-66.4-8.8l-64,67.2l5.6,31.2l109.2,109.2c7.2,7.2,18.8,7.2,26,0l0,0 c6.8-6.8,7.2-18,0.8-25.2l6.4,6.4c7.2,7.2,18.8,7.2,26,0c6.8-6.8,7.2-18,0.8-25.2l6.4,6.4c7.2,7.2,18.8,7.2,26,0 c6.8-6.8,7.2-18,0.8-25.2l6.4,6.4c7.2,7.2,18.8,7.2,26,0C362.4,314.8,362.4,302.8,355.2,295.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M206.8,192.4c3.2-2.4,8-2.8,11.2-4.4c7.6-2.4,15.2-4.8,23.2-7.2c8.8-1.2,17.6-6,27.2-6.4 c6.8-0.4,13.6,1.6,20,3.2c19.6,5.2,38.8,10.4,58.4,15.6c9.6,25.2,19.6,50.4,29.2,75.6c0.4,0.8,0.4,1.2,0.4,2 c-0.4,0.8-0.8,1.2-1.6,1.6c-4.8,3.2-26,17.2-27.2,16c-24.4-22.8-44-37.2-63.6-56c-5.2-5.2-18.8-16-18.8-16s-18.4,0-31.6-0.8 c-3.6,6.8-9.2,17.6-14.8,23.2c0,0-10,3.6-18,5.2c-3.2,0.8-6.4-2-6.8-5.2c-0.8-12.8,1.6-25.6,6.8-37.6 C202,197.6,204,194.4,206.8,192.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M444.4,258.4l-37.6-100c-1.6-4.4-6.8-6.8-11.2-5.2L345.2,172c-4.4,1.6-6.8,6.8-5.2,11.2l37.6,100 c1.6,4.4,6.8,6.8,11.2,5.2l50.4-18.8C444,267.6,446,262.8,444.4,258.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M188.4,162L148,126.4c-3.6-3.2-8.8-2.8-12,0.8l-70.8,80c-3.2,3.6-2.8,8.8,0.8,12l40.4,35.6 c3.6,3.2,8.8,2.8,12-0.8l70.8-80C192.4,170.8,192,165.2,188.4,162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M138.4,259.6l-18,13.6c-8,6-10.8,17.6-4.8,26s18,10.4,26,4.4l6.8-4.8c0.4-0.4,1.2-0.8,1.6-1.2 l10.8-8c8.8-6.4,10-19.6,2-27.6l-0.4-0.4C156,255.2,145.6,254.4,138.4,259.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M180,320.8l6.8-4.8c9.2-6.8,10-20,2-27.6l0,0c-6.4-6.4-16.8-7.2-24-1.6l-16.4,12.4 c-7.6,6.8-8,18.8-0.8,26.4c6.4,6.8,17.2,7.2,24.8,1.6l6-4.4C179.2,321.6,179.6,321.2,180,320.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M150,297.2c-0.4,0.4-1.2,0.8-1.6,1.2L150,297.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M210.4,344l2.8-2c9.2-6.8,10-20,2-27.6l0,0c-6.4-6.4-16.8-7.2-24-1.6l-12.8,9.2 c-7.6,6.8-8,18.8-0.8,26.4c6.4,6.8,17.2,7.2,24.8,1.6l6-4.4C209.2,345.2,209.6,344.4,210.4,344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M180,320.8c-0.4,0.4-1.2,0.8-1.6,1.2L180,320.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M208.8,345.6c-7.6,6.8-8,18.8-0.8,26.4c6.4,6.8,17.2,7.2,24.8,1.6l6.8-4.8c9.2-6.8,10-20,2-28l0,0 c-6.4-6.4-16.8-7.2-24-1.6L208.8,345.6z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 404.8,
    cy: 255.6,
    r: 9.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF7058"
    },
    cx: 102.8,
    cy: 218,
    r: 9.2
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshakeDealSvgrepoCom);
export default __webpack_public_path__ + "static/media/handshake-deal-svgrepo-com.808fe429ac0eb16a0a7df9023a96fc7a.svg";
export { ForwardRef as ReactComponent };